/**
 * 全局配置文件
 */
export default {
  indexTitle: 'AI智能助手',
  clientId: 'saber3', // 客户端id
  clientSecret: 'saber3_secret', // 客户端密钥
  //HTTP状态码白名单
  statusWhiteList: [],
  //oauth2配置
  oauth2: {
    // 使用后端工程 @org.springblade.test.Sm2KeyGenerator 获取
    publicKey: '04971efa4e29526f6e2633b28e5cee6b60e000aadc3c5ab0c80a034cd84c2633ce1b63015da2ae479d865b83493ce386ebb4821a33ebf1988885d39bcf1d41eda9'
  }
};
